import React from 'react';
import './progressSpinner.css'
import { ProgressSpinner as PrimeProgressSpinner } from 'primereact/progressspinner';

const InnerProgressSpinner = ({ loading, loadingText }) => {
    const displayStyle = loading ? 'progressVisible innercontainer' : 'progressHide';

    return (

        <div className={`${'InnerProgressSpinner '} ${displayStyle}`} >
            <div className='boxInner'>
                <PrimeProgressSpinner id="progressSpinnerCircle" className="progressPos" strokeWidth="2"
                    style={{ width: '100px', height: '100px' }} />
            </div>
            {loadingText && (loadingText + '').trim() !== '' && <div className='box'>{loadingText}</div>}
        </div>
    );
}
export default InnerProgressSpinner;
